import { cn } from '@repo/ui/lib/utils'
import { ComponentPropsWithoutRef, ElementType, FunctionComponent } from 'react'

export interface Props extends ComponentPropsWithoutRef<'p'> {
  amount: number
  currencyCode: string
  className?: string
  as?: ElementType
}

const Price: FunctionComponent<Props> = ({ amount, currencyCode, className, as = 'span' }) => {
  const Type = as
  const isInteger = Number.isInteger(amount)
  const formattedAmount = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyCode,
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: 2,
    // Show 0 decimal places if integer, otherwise 2
    minimumFractionDigits: isInteger ? 0 : 2,
  })
    .format(amount)
    // Remove whitespace between currency symbol and number
    .replace(/\s/g, '')

  return (
    <Type suppressHydrationWarning={true} className={cn('whitespace-nowrap', className)}>
      {formattedAmount}
    </Type>
  )
}

export default Price
